import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useEphemeralStore } from '@/lib/app-store';
import { useEffect } from 'react';
import { waitForConfirmedDonationFn } from '@/lib/data';
import { trpc } from '@/lib/trpc';
import { useRouteContext } from '@tanstack/react-router';

export function UpdatePortalOnConfirmedDonationFlow() {
	const { portalId } = useRouteContext({ from: '__root__' });
	const queryClient = useQueryClient();
	const donationToConfirm = useEphemeralStore((store) => store.donationToConfirm);
	const setDonationToConfirm = useEphemeralStore((store) => store.setDonationToConfirm);
	const donationConfirmed = useEphemeralStore((store) => store.donationConfirmed);
	const setDonationConfirmed = useEphemeralStore((store) => store.setDonationConfirmed);
	const { mutateAsync: refreshAggregatesCache } = useMutation(trpc.portal.refreshAggregatesCache.mutationOptions());

	useEffect(() => {
		if (!donationToConfirm) return;
		if (!portalId) return;

		const waitForConfirmedDonation = async () => {
			console.time('[WORLDCOO] Donation confirmed in');
			console.info('[WORLDCOO] Waiting for donation confirmation...');
			for await (const msg of await waitForConfirmedDonationFn({ data: donationToConfirm.id })) {
				if (msg === 'donation.confirmed') {
					console.time('[WORLDCOO] Waiting to refresh aggregates cache...');
					await refreshAggregatesCache({
						portalId: portalId,
					});
					console.timeEnd('[WORLDCOO] Waiting to refresh aggregates cache...');

					await queryClient.invalidateQueries({ queryKey: trpc.portal.getCampaignsAggregates.queryKey({ portalId }) });

					console.info('[WORLDCOO] Aggregates refreshed');
					console.timeEnd('[WORLDCOO] Donation confirmed in');
					setDonationConfirmed(true);
				} else {
					console.warn('[WORLDCOO] Donation confirmation timed out');
				}
				setDonationToConfirm(undefined);
			}
		};

		waitForConfirmedDonation();
	}, [
		donationConfirmed,
		donationToConfirm,
		portalId,
		queryClient,
		refreshAggregatesCache,
		setDonationConfirmed,
		setDonationToConfirm,
	]);

	return null;
}
